import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UserState } from './types'
import { ls } from '~/utils/localStorage'

const INITIAL_STATE: UserState = {
  isAuth: ls.get('is_auth') || false,
  isFetching: ls.get('is_fetching') || false,
  data: ls.get('user') || {},
}

export const slice = createSlice({
  name: 'user',
  initialState: INITIAL_STATE,
  reducers: {
    isFetching(state) {
      state.isFetching = true
    },
    updateUserData(state, action: PayloadAction<any>) {
      const { data } = action.payload
      state.isAuth = true
      state.isFetching = false
      state.data = data
    },
    clearState(state) {
      state.isAuth = false
      state.isFetching = false
      state.data = {}
      ls.remove('is_auth')
      ls.remove('is_fetching')
      ls.remove('user')
    },
  },
})

export const { isFetching, updateUserData, clearState } = slice.actions

export default slice.reducer
